import { render, staticRenderFns } from "./EditTaxonomyOrder.vue?vue&type=template&id=016bb10f&"
import script from "./EditTaxonomyOrder.vue?vue&type=script&lang=js&"
export * from "./EditTaxonomyOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports